import React from 'react';

function CustomDialog({ isOpen, title, message, onConfirm, onCancel }) {
  if (!isOpen) return null;

  return (
    <>
      {/* Overlay Background */}
      <div
        className="fixed top-0 left-0 w-full h-full bg-black opacity-50 z-40"
      ></div>

      {/* Dialog Content */}
      <div 
        className="fixed top-0 left-0 w-full h-full flex items-center justify-center z-50"
      >
        <div 
          className="p-8 bg-white rounded-lg shadow-2xl max-w-md w-full mx-4"
          onClick={(e) => e.stopPropagation()}
        >
          <h2 className="mb-4 text-2xl font-semibold">{title}</h2>
          <p className="mb-6 text-gray-700">{message}</p>
          <div className="flex justify-end gap-2">
            <button 
              className="px-4 py-2 text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300 focus:outline-none" 
              onClick={onCancel}
            >
              Cancel
            </button>
            <button 
              className="px-4 py-2 text-white bg-red-500 rounded-md hover:bg-red-600 focus:outline-none" 
              onClick={onConfirm}
            >
              Confirm
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default CustomDialog;
